import { scrollToSection } from "./Navbar";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[rgba(212,175,55,0.2)] bg-[#09090b] px-6 lg:px-10 py-14"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img
            src="/sk-logo-gold.png"
            alt="SK Media Events"
            className="h-16 w-auto mb-4"
          />
          <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
            Event architects of Bengaluru — drum circles, venue production and
            artist management, finished in gold.
          </p>
        </div>
        <div>
          <h4 className="font-cinzel text-xs tracking-[0.3em] uppercase text-[#d4af37] mb-5">
            Explore
          </h4>
          <div className="flex flex-col gap-3">
            {[
              ["Services", "#services"],
              ["Manifesto", "#manifesto"],
              ["Gallery", "#gallery"],
              ["Enquire", "#enquiry"],
            ].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-link-${label.toLowerCase()}`}
                onClick={() => scrollToSection(href)}
                className="text-left text-sm text-zinc-400 hover:text-[#d4af37] transition-colors w-fit"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-cinzel text-xs tracking-[0.3em] uppercase text-[#d4af37] mb-5">
            Reach Us
          </h4>
          <p className="text-sm text-zinc-400 leading-relaxed">
            <a
              data-testid="footer-email-link"
              href="mailto:karthik@skmediaevents.com"
              className="hover:text-[#d4af37] transition-colors"
            >
              karthik@skmediaevents.com
            </a>
            <br />
            <a
              data-testid="footer-phone-link"
              href="tel:+919741106724"
              className="hover:text-[#d4af37] transition-colors"
            >
              +91 97411 06724
            </a>
            {" · "}
            <a
              data-testid="footer-phone-link-2"
              href="tel:+917892272280"
              className="hover:text-[#d4af37] transition-colors"
            >
              +91 78922 72280
            </a>
            <br />
            GSTIN: 29ANXPG9863F2Z3
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-[rgba(212,175,55,0.1)] flex flex-wrap justify-between gap-4">
        <p className="text-xs text-zinc-600 tracking-wider">
          © {new Date().getFullYear()} SK Media Events. All rights reserved.
        </p>
        <p className="text-xs text-zinc-600 tracking-[0.3em] uppercase">
          Crafted in black & gold
        </p>
      </div>
    </footer>
  );
}
